import PropTypes from 'prop-types';

const initialValuesShape = PropTypes.shape({
  oldPassword: PropTypes.string,
  newPassword: PropTypes.string,
  newPasswordConfirmation: PropTypes.string,
});

export { initialValuesShape };
